import MeasurementPage from '@components/MeasurementPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'height'

export default function HeightPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value || undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleMeasurementSubmit = (
    value: string,
    unit: string,
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'What is your height?',
      answer_key: value.toLowerCase(),
      answer: `${value} ${unit}`,
    }

    const formData = new FormData(event.currentTarget)
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <MeasurementPage
      heading="pages.onboarding.height.heading"
      description="pages.onboarding.height.description"
      placeholders={{ cm: '165', in: '65' }}
      units={['cm', 'in']}
      defaultUnit="cm"
      onSubmit={handleMeasurementSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
